<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card>
          <v-toolbar
            color="primary"
            flat
            short
          >
            <v-toolbar-title><v-icon>mdi-lock</v-icon></v-toolbar-title>
          </v-toolbar>

          <v-card-text class="px-5 pt-5">
            <v-form
              ref="loginForm"
              autocomplete="off"
            >    
                <v-text-field v-model="password" id="password" outline autocomplete="new-password"
                  type="password" label="Password" :error-messages="errors.password" :rules="passwordRules" @input="error = false">
                </v-text-field>
                <v-text-field id="wachtwoord-bevestigen" outline v-model="confirmPassword" type="password"
                  autocomplete="new-password" label="Confirm password" :rules="[confirmPasswordRules]" @input="error = false">
                </v-text-field>

                <v-input
                  v-if="error"
                  error-messages="Passwords do not match"
                ></v-input>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-5 pb-5">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submitResetPassword">Reset</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ApiService from '@/services/api.service'
import _ from 'lodash'

export default {
  name: 'ResetPassword',
  components: {
  },
  data: () => ({
    password: '',
    confirmPassword: '',

    resetToken : '',

    errors: {},
    error: false,

    passwordRules: [password => !!password || "Password is required"],

  }),
  created() {
    this.$store.dispatch('session/fullHeight', true)
    this.$store.dispatch('session/title', null)
  },
  destroyed() {
    this.$store.dispatch('session/fullHeight', false)
  },
  methods: {
    getToken() {
      return this.$route.query.token
    },
    confirmPasswordRules() {
      if (this.password !== this.confirmPassword) {
        return "Passwords doesn't match."
      }
      return true
    },

    submitResetPassword() {
      ApiService.resetPassword(this.getToken(), {
        password: this.password,
      }).then(() => {
        console.log('noerror')
        //this.$store.dispatch('session/alert', 'Je wachtwoord is gewijzigd.')
        this.$router.push({ name: 'login' })
      }).catch(errors => {
        console.log('error')
        if (_.isEmpty(errors)) {
          errors.password = 'Password is not changed. Please try again.'
        }
        this.errors = errors
      })
    },
  },
}
</script>
